<template>
  <tr @click="!isFull && $emit('show', campaign)" :style="{cursor: isFull ? 'normal' : 'pointer'}">
    <template v-if="isDraft">
      <td>
        <span class="text-sm">{{ campaign.text }}</span>
      </td>
      <td>{{ campaign.senderName }}</td>
      <td>{{ campaign.sendDate | full }}</td>
      <td>{{ campaign.listName }}</td>
    </template>
    <template v-else-if="isFull">
      <td><span class="text-sm">{{ campaign.name }}</span></td>
      <td>{{ campaign.text }}</td>
      <td>{{ campaign.senderName }}</td>
      <td>{{ campaign.sendDate | full }}</td>
      <td>{{ campaign.listName }}</td>
      <td>{{ campaign.contactsNumber }}</td>
      <td>{{ userName }}</td>
      <td>
        <span v-if="campaignStatus === 'draft'" class="badge badge-pill badge-primary">{{ campaignStatus }}</span>
        <span v-else-if="campaignStatus === 'live'" class="badge badge-pill badge-danger">{{ campaignStatus }}</span>
        <span v-else-if="campaignStatus === 'sent'" class="badge badge-pill badge-success">{{ campaignStatus }}</span>
      </td>
      <td class="action-btns" style="position:relative;">
        <button v-if="campaignStatus !== 'sent'" :disabled="isDisabled" :class="campaignStatus === 'live' ? 'btn btn-warning' : 'tooltip-btn btn btn-success'" @click="toggleCampaignStatus">
          <i :class="campaignStatus === 'live' ? 'fas fa-pause' : 'fas fa-play'"></i>
        </button>
        <button v-if="campaignStatus !== 'sent'" class="btn btn-danger" @click="$emit('show-delete-campaign-modal', campaign)"><i class="fas fa-trash-alt"></i></button>
        <div v-if="isDisabled && campaignStatus !== 'sent'" class="tooltip-info">{{ missingInfosGenerator }}</div>
      </td>
    </template>
    <template v-else>
      <td><span class="text-sm">{{ campaign.name }}</span></td>
      <td>{{ campaign.text }}</td>
      <td>{{ campaign.senderName }}</td>
      <td>{{ campaign.sendDate | full }}</td>
      <td>{{ campaign.listName }}</td>
      <td class="text-center">
        <button class="btn btn-secondary"><i class="fas fa-bars"></i></button>
      </td>
    </template>
  </tr>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      campaignStatus: ''
    };
  },
  mounted() {
    if (this.campaign.status === 'draft') this.campaignStatus = 'draft';
    if (this.campaign.status === 'live') this.campaignStatus = 'live';
    if (this.campaign.status === 'sent') this.campaignStatus = 'sent';
  },
  props: {
    campaign: {
      required: true,
      type: Object
    },
    users: Array,
    isDraft: {
      default: false,
      type: Boolean
    },
    isFull: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    ...mapActions({
      createOrUpdateCampaign: 'campaigns/createOrUpdateCampaign',
      getAll: 'campaigns/getAll'
    }),
    toggleCampaignStatus() {
      const requestedStatus = this.campaign.status === 'live' ? 'draft' : 'live';
      this.createOrUpdateCampaign({ userId: this.$store.state.auth.user.id, action: 'update', campaignId: this.campaign.id, senderName: this.campaign.senderName, text: this.campaign.text, listId: this.campaign.listId, name: this.campaign.name, status: requestedStatus })
        .then(() => {
          this.campaignStatus = this.$store.state.campaigns.campaigns.find(campaign => campaign.id === this.campaign.id).status;
        })
        .catch(() => this.$eventBus.$emit('fetch-data-error'));
    }
  },
  computed: {
    isDisabled() {
      if ((this.campaign.text === null || this.campaign.senderName === null || this.campaign.listName === undefined) && this.campaignStatus !== 'live') return true;
      return false;
    },
    missingInfosGenerator() {
      let missingInfos = 'Veuillez entrer : ';
      if (this.campaign.text === null) missingInfos += 'un message, ';
      if (this.campaign.senderName === null) missingInfos += 'un émetteur, ';
      if (this.campaign.listName === undefined) missingInfos += 'une liste de destination, ';
      return missingInfos.substring(0, missingInfos.length - 2);
    },
    userName() { // eslint-disable-line
      const { users } = this;

      for (let i = 0; i < users.length; i++) {
        const user = users[i];
        if (user.id === this.campaign.user_id) {
          return `${user.firstname} ${user.lastname}`;
        }
      }
    }
  }
};
</script>

<style scoped>
.tooltip-info {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 103%;
  width: 200px;
  text-align: center;
  background: #f5365c;
  color:white;
  border-radius: 4px;
  padding: 5px;
  opacity: 0;
  visibility: hidden;
}
.tooltip-info:after {
  content:'';
  display:block;
  width:0;
  height:0;
  position:absolute;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left:8px solid #f5365c;
  right:-8px;
  top:6px;
}
.action-btns:hover .tooltip-info {
  opacity: 1;
  visibility: visible;
}
</style>
